import React, { lazy, Suspense } from 'react';
import { createPortal } from 'react-dom';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { resetActiveModal } from '../../ducks/modals';
import { LIGHTBOX, SAVE_TO_LIST, SUGGESTIONS_MODAL, INVITE_FRIENDS_MODAL, FIND_FRIENDS_MODAL, CONNECT_MODAL } from '../../constants';

const Lightbox = lazy(() => import('../../../../components/shared/Lightbox'));
const ReduxListModal = lazy(() => import('../modals/lists/ReduxListModal'));
const UserConnectionsSuggestionsModal = lazy(() => import('../modals/connections/UserConnectionsSuggestionsModal'));
const UserConnectionsInviteFriendsModal = lazy(() => import('../modals/connections/UserConnectionsInviteFriendsModal'));
const UserConnectionsFindFriendsModal = lazy(() => import('../modals/connections/UserConnectionsFindFriendsModal'));
const ConnectModal = lazy(() => import('../modals/connections/ConnectModal'));

const getActiveModal = (activeModal, modalProps, dispatch) => {
  if (!activeModal) {
    return null;
  }

  const closeModal = () => {
    dispatch(resetActiveModal());
  };

  switch (activeModal) {
    case LIGHTBOX:
      return <Lightbox {...modalProps} handleCloseRequest={closeModal} />;
    case SAVE_TO_LIST:
      return <ReduxListModal {...modalProps} closeModal={closeModal} />;
    case SUGGESTIONS_MODAL:
      return <UserConnectionsSuggestionsModal {...modalProps} closeModal={closeModal} />;
    case INVITE_FRIENDS_MODAL:
      return <UserConnectionsInviteFriendsModal closeModal={closeModal} />;
    case FIND_FRIENDS_MODAL:
      return <UserConnectionsFindFriendsModal closeModal={closeModal} />;
    case CONNECT_MODAL:
      return <ConnectModal closeModal={closeModal} />;
    default:
      return null;
  }
};
// this component works with redux to render the active modal
const ModalRenderer = () => {
  const dispatch = useDispatch();
  const { activeModal, modalProps } = useSelector(state => state.modals, shallowEqual);
  const modalComponent = getActiveModal(activeModal, modalProps, dispatch);

  if (!modalComponent) {
    return null;
  }

  return createPortal(<Suspense fallback={null}>{modalComponent}</Suspense>, document.getElementById('modalPortal'));
};

export default ModalRenderer;
